var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeRel1B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2641_6775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 47C36.9787 47 47.5 36.4787 47.5 23.5C47.5 10.5213 36.9787 0 24 0C11.0213 0 0.5 10.5213 0.5 23.5C0.5 36.4787 11.0213 47 24 47Z",
    fill: "#F2F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.1918C17.5 17.6105 17.7371 17.053 18.159 16.6419C18.581 16.2309 19.1533 16 19.75 16H27.25C27.8467 16 28.419 16.2309 28.841 16.6419C29.2629 17.053 29.5 17.6105 29.5 18.1918V29.9016C29.5 30.7929 28.465 31.3116 27.721 30.7936L23.5 27.8567L19.279 30.7936C18.5343 31.3123 17.5 30.7936 17.5 29.9023V18.1918Z",
    fill: "#9747FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2641_6775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeRel1B);
export default __webpack_public_path__ + "static/media/icone-rel-1B.8ee0119c7ec66234de7357a9c2a79de5.svg";
export { ForwardRef as ReactComponent };